"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFeatureEnabled = exports.initFeatureFlags = exports.getFeatureAttributes = void 0;
var getFeatureAttributes_1 = require("./getFeatureAttributes");
Object.defineProperty(exports, "getFeatureAttributes", { enumerable: true, get: function () { return getFeatureAttributes_1.getFeatureAttributes; } });
var initFeatureFlags_1 = require("./initFeatureFlags");
Object.defineProperty(exports, "initFeatureFlags", { enumerable: true, get: function () { return initFeatureFlags_1.initFeatureFlags; } });
var isFeatureEnabled_1 = require("./isFeatureEnabled");
Object.defineProperty(exports, "isFeatureEnabled", { enumerable: true, get: function () { return isFeatureEnabled_1.isFeatureEnabled; } });
